module.exports = __webpack_public_path__ + "static/img/anli1.f4f1ad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/anli1.png
// module id = NjqJ
// module chunks = 1